
angular.module("EICDataStream3.logging", [])
  .directive('logEvent', ['$timeout', '$interval', '$http',
  function ($timeout, $interval, $http) {
    return {
      scope: {
        initialDelay:   '=',     // time to wait before first firing
        intervalDelay:  '=',     // {optional} time between subsequent firings. Default is same as initial delay
        data:           '=',     // instance-specific data object
        maxSeconds:     '=',     // maximum time to record in the log. Default is 300 seconds (5 mins)
        mode:           '@',     // [single | interval] - default is single
        operation:      '@'      // string for server-side interpretation of logging operation
      },
      restrict: "AE",
      replace: false,
      link: function ($scope) {
          var defaultMaxSeconds = 300;
          var defaultInitialDelay = 0;
          var defaultMode = "single";
          var timeoutPromise = null;
          var intervalPromise = null;

          var mode = $scope.mode.toLowerCase() || defaultMode;

          if (!$scope.operation) throw new Error("log-event: 'operation' is a required parameter - logging operation aborted");
          var operation = $scope.operation.toLowerCase();

          // clone the logData object to prevent multiple instances
          // from interfering with each other
          $scope.data = $scope.data || {};
          var logData = angular.copy($scope.data);

          logData.initialDelay = $scope.initialDelay || defaultInitialDelay;
          logData.elapsedTime = logData.initialDelay;

           var sendDataPacketToLogger = function() {
            // call back to the server with the data packet
            $http.post("/api/LogEvent", {mode: mode, operation: operation, data: logData});
          };

          // is this a $timeout or an interval?
          if(mode==="interval") {
            logData.intervalDelay = $scope.intervalDelay || $scope.initialDelay;
            logData.maxSeconds = $scope.maxSeconds || defaultMaxSeconds;

            // this is an interval timer
            // implement as a one-shot using $timeout for the initial period
            // and then set up a $interval timer for subsequent calls
            timeoutPromise = $timeout(function(){
              sendDataPacketToLogger();

              intervalPromise = $interval(function(){
                  var elapsedTime = logData.initialDelay;
                  return function(){
                    // keep track ot total elapsed time
                    elapsedTime += logData.intervalDelay;
                    logData.elapsedTime = elapsedTime;

                    // turn off the interval timer if maxSeconds has been exceeded
                    if (elapsedTime >= logData.maxSeconds) $interval.cancel(intervalPromise);

                    sendDataPacketToLogger();
                  };
                }(), logData.intervalDelay * 1000);
            }, logData.initialDelay * 1000);

          }
          else {
            // this is a one-shot timer - use $timeout
            timeoutPromise = $timeout(sendDataPacketToLogger, logData.initialDelay * 1000);
          }


          $scope.$on('$destroy', function() {
            // When the directive is destroyed, ie when the
            // user navigates away from the project, cancel
            // all timers.
            if(angular.isDefined(timeoutPromise)) $timeout.cancel(timeoutPromise);
            if(angular.isDefined(intervalPromise)) $interval.cancel(intervalPromise);


          });
        }
    };

  }]);
